export default {
  title: 'Angiv refunderingsbeløb',
  description: 'Kan refunderes: {{amount}}',
  form: {
    amount: {
      label: 'Refunder',
    },
    reason: {
      label: 'Årsag',
      options: {
        requested_by_customer: 'ønsket af kunden',
        reclamation: 'reklamation',
        communication_error: 'kommunikationsfejl',
        other: 'andet',
      },
    },
    manual_reason: {
      label: 'Angiv refunderingsårsag',
    },
  },
  feedback: {
    amount_too_small: 'Minimum refunderingsbeløb {{amount}}',
    amount_too_big: 'Maksimum refunderingsbeløb {{amount}}',
    payment_frozen: 'Kunden har allerede anmodet om refundering. {{provider}} er i kontakt med kunden om refunderingen',
  },
  buttons: {
    refund: 'Refunder',
    cancel: 'Annuller',
  },
  toasts: {
    refund_successful: 'Refundering på {{amount}} er igangsat!',
  },
};
